import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import {
  cleanCsvString,
  delete_Record,
  errorMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetAllCustomerRepresentativeDropDown,
  POST_GetCustomerDDLList,
  POST_GetReportingsDetailByInwardMaterialID,
  POST_GetReportingsList,
  POST_GetReportingsSendDraftCopyEmail,
  POST_GetReportPrintingApprovalDetail,
  POST_ReportingsDelete,
  POST_ReportingsSendDraftCopyEmailSend,
  POST_ReportingsUploadScanCopiesInsertUpdate,
  POST_ReportPrintingApproval,
} from "../../../helpers/url_helper";
import moment from "moment";
import { useFilter } from "../../../../context/FilterContext";

const ReportPrinting = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "report-printing" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "report-printing" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "report-printing" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "report-printing" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  //const [reportingList, setReportingList] = useState([]);
  const [customerOptionList, setCustomerList] = useState([]);
  const [tCNumber, setTCNumber] = useState("");

  const [addUploadScanCopyModal, setAddUploadScanCopyModal] = useState(false);
  const [uploadScanCopyFilePath, setUploadScanCopyFilePath] = useState("");
  const [uploadScanCopyFile, setUploadScanCopyFile] = useState("");
  const [customerRepresentativeOptions, setCustomerRepresentativeOptions] =
    useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const uploadScanCopyOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Save", value: 1 },
    { label: "Draft Print", value: 2 },
    { label: "Print", value: 3 },
  ];

  const validationSchemaReporting = Yup.object().shape({});
  const formik = useFormik({
    validationSchemaReporting,
    onSubmit: (values, formikHelpers) =>
      handleValidReportingSubmit(values, formikHelpers),
    initialValues: {
      reportingList: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidReportingSubmit,
    values: { reportingList },
  } = formik;

  const validationSchema = Yup.object().shape({});

  const currentDate = new Date();

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TCNo: filter && filter?.page == "report-printing" ? filter?.TCNo : "",
      InwardNo:
        filter && filter?.page == "report-printing" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "report-printing"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate:
        filter && filter?.page == "report-printing"
          ? filter?.ToDate
          : new Date(),
      CustomerID:
        filter && filter?.page == "report-printing" ? filter?.CustomerID : "",
      ReportingStatus:
        filter && filter?.page == "report-printing"
          ? filter?.ReportingStatus
          : -1,
      UploadScanCopy:
        filter && filter?.page == "report-printing"
          ? filter?.UploadScanCopy
          : -1,
      Search: filter && filter?.page == "report-printing" ? filter?.Search : "",
      CustomerRepresentativeIDEncrypt:
        filter && filter?.page == "report-printing"
          ? filter?.CustomerRepresentativeIDEncrypt
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      TCNo,
      FromDate,
      ToDate,
      InwardNo,
      CustomerID,
      ReportingStatus,
      Search,
      UploadScanCopy,
      CustomerRepresentativeIDEncrypt,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      TCNo: "",
      InwardNo: "",
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      CustomerID: "",
      ReportingStatus: -1,
      UploadScanCopy: -1,
      Search: "",
      CustomerRepresentativeIDEncrypt: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "report-printing",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Search: Search,
      TCNo: TCNo,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerID: CustomerID,
      ReportingStatus: ReportingStatus,
      UploadScanCopy: UploadScanCopy,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      TCNo: TCNo,
      InwardNo: InwardNo,
      ReportingStatus: ReportingStatus,
      CustomerIDEncrypted: CustomerID,
      UploadScanCopy: UploadScanCopy,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
      // FromDate: FromDate ? moment(FromDate).format("DD-MMM-yyyy") : "",
      // ToDate: ToDate ? moment(ToDate).format("DD-MMM-yyyy") : "",
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetReportingsList, payload)
      .then((response) => {
        //setReportingList(response?.List);

        formik.setFieldValue(
          "reportingList",
          response?.List?.map((item) => ({
            ...item,
            showTest: false,
          })),
        );
        setRecordCount(response?.TotalRecordCount);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getCustomerDDL();
    getCustomerRepresentativeDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerRepresentativeDDL = () => {
    setIsLoading(true);
    post(POST_GetAllCustomerRepresentativeDropDown, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerRepresentativeOptions(
            response?.ListOfCustomerRepresentative?.map((item) => ({
              label: item?.ProjectHandleByName,
              value: item?.ProjectHandleByEncrypted,
              IsDefault: item?.IsDefault,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addUploadScanCopy = () => {
    formikUploadScanCopy.resetForm();
    setAddUploadScanCopyModal(true);
  };

  const validationSchemaUploadScanCopy = Yup.object().shape({
    UploadScanCopyFile: Yup.string()
      .trim()
      .required("Upload Scan Copy File is required field"),
  });

  const formikUploadScanCopy = useFormik({
    validationSchema: validationSchemaUploadScanCopy,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitUploadScanCopy(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypt: "",
      UploadScanCopyIDEncrypt: "",
      UploadScanCopyFile: "",
      InwardIDEncrypted: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { UploadScanCopyFile },
  } = formikUploadScanCopy;

  const handleValidSubmitUploadScanCopy = (values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("InwardMaterialIDEncrypt", values?.InwardMaterialIDEncrypt);
    formData.append(
      "InwardIDEncrypted",
      AuthUser?.ULRNoGenerateInwardWise ? values?.InwardIDEncrypted : "",
    );
    formData.append("UploadScanCopyIDEncrypt", values?.UploadScanCopyIDEncrypt);
    formData.append("ScanCopyFile", uploadScanCopyFile ?? "");
    formData.append("ScanCopyFilePath", uploadScanCopyFilePath ?? "");
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    postFormData(POST_ReportingsUploadScanCopiesInsertUpdate, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            setAddUploadScanCopyModal(false);
            getData(1, currentSizePerPage);
          }, 1000);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadUploadScanCopyFile = (e) => {
    setUploadScanCopyFile(null);
    if (e.target.files[0]) {
      const file = e.target.files[0];

      const testReportUploadingSize =
        AuthUser?.Permissions?.TestReportUploadingSize;

      if (
        testReportUploadingSize &&
        file.size > testReportUploadingSize * 1024 * 1024
      ) {
        warningMessage(
          `File size should not be greater than ${testReportUploadingSize} MB!`,
        );
        e.target.value = "";
        return;
      }
      // var pattern = /image-*/;
      var pattern = /(.png|.gif|.jpeg|.jpg|pdf)$/;
      if (!file.type.match(pattern)) {
        formikUploadScanCopy.setFieldValue("UploadScanCopyFile", "");
        setUploadScanCopyFile(null);
        warningMessage("Select valid file!");
      } else {
        formikUploadScanCopy.setFieldValue("UploadScanCopyFile", file);
        setUploadScanCopyFile(file);
      }
    }
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const [showSendDraftCopyEmailModal, setShowSendDraftCopyEmailModal] =
    useState(false);

  const openSendDraftCopyEmailDialog = async (
    InwardMaterialID,
    InwardID,
    InwardNo,
    TCNo,
    ReportingID,
  ) => {
    formikSendDraftCopyEmail.resetForm();
    // if (InwardMaterialID) {
    setShowSendDraftCopyEmailModal(true);
    formikSendDraftCopyEmail.setFieldValue(
      "InwardMaterialIDEncrypted",
      InwardMaterialID,
    );
    formikSendDraftCopyEmail.setFieldValue("InwardIDEncrypted", InwardID);
    formikSendDraftCopyEmail.setFieldValue("InwardNo", InwardNo);
    formikSendDraftCopyEmail.setFieldValue("TCNo", TCNo);
    formikSendDraftCopyEmail.setFieldValue("ReportingIDEncrypted", ReportingID);

    getTestDetailsAndProject(InwardMaterialID, InwardID);
    //}
  };

  const validationSchemaSendDraftCopyEmail = Yup.object().shape({});

  const formikSendDraftCopyEmail = useFormik({
    validationSchemaSendDraftCopyEmail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendDraftCopyEmail(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypted: "",
      InwardIDEncrypted: "",
      AdditionalEmailID: "",
      ListOfCustomerContactPerson: [],
      ListOfReportingTest: [],
      EmailIDs: "",
      InwardNo: "",
      TCNo: "",
      ReportingIDEncrypted: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      AdditionalEmailID,
      ListOfCustomerContactPerson,
      ListOfReportingTest,
      EmailIDs,
      InwardMaterialIDEncrypted,
    },
  } = formikSendDraftCopyEmail;

  const handleValidSubmitSendDraftCopyEmail = async (values) => {
    if (values?.InwardIDEncrypted) {
      let listOfAdditionalEmails = values?.AdditionalEmailID?.trim()
        ? cleanCsvString(values?.AdditionalEmailID)?.split(",")
        : [];

      const selectedCount = values?.ListOfReportingTest?.flatMap(
        (x) => x.ListOfReportingsTest || [],
      )?.filter((xsub) => xsub.IsSelected === true).length;

      // if (
      //   values?.ListOfReportingTest?.filter((x) => x.IsSelected == true)
      //     ?.length == 0
      // ) {
      if (selectedCount === 0) {
        warningMessage("Please select atleast one test name to send email!");
      } else {
        if (
          values?.ListOfCustomerContactPerson?.filter(
            (x) => x.IsSelected == true,
          )?.length == 0 &&
          listOfAdditionalEmails?.length == 0
        ) {
          warningMessage(
            "Please select contact person or enter additional email to send!",
          );
        } else {
          if (
            listOfAdditionalEmails?.length > 0 &&
            listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
              ?.length > 0
          ) {
            formikSendDraftCopyEmail.setFieldError(
              "AdditionalEmailID",
              "Please check it contains invalid email address",
            );
            formikSendDraftCopyEmail.setFieldTouched("AdditionalEmailID", true);
          } else {
            setIsLoading(true);

            let emailCsv = "";
            let testIDs = "";
            let ContactPersonName = "";
            let InwardMaterialIDs = "";
            let TCNos = "";

            Promise.all(
              values?.ListOfReportingTest?.map((item) => {
                item?.ListOfReportingsTest?.filter(
                  (x) => x.IsSelected == true,
                )?.map((x) => {
                  testIDs =
                    testIDs +
                    x.TestMasterIDEncrypt +
                    ":::" +
                    x.InwardMaterialIDEncrypt +
                    ", ";
                  InwardMaterialIDs =
                    InwardMaterialIDs + x.InwardMaterialIDEncrypt + ", ";
                  TCNos = TCNos + x.TCNo + ", ";
                });
              }),

              // values?.ListOfReportingTest?.filter(
              //   (x) => x.IsSelected == true
              // )?.map((x) => {
              //   testIDs = testIDs + x.TestMasterID + ", ";
              // }),

              values?.ListOfCustomerContactPerson?.filter(
                (x) => x.IsSelected == true,
              )?.map((x) => {
                emailCsv =
                  emailCsv +
                  x.ContactPersonEmailID +
                  ":::" +
                  x.ContactPersonID +
                  ", ";
              }),

              values?.ListOfCustomerContactPerson?.filter(
                (x) => x.IsSelected == true,
              )?.map((x) => {
                //ContactPersonName = ContactPersonName + x.ContactPerson + ", ";
                ContactPersonName = x.ContactPerson;
              }),

              listOfAdditionalEmails?.map((email) => {
                emailCsv = emailCsv + email + ":::" + 0 + ", ";
              }),
              (emailCsv = cleanCsvString(emailCsv)),
            );

            let payload = {
              BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
              CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
              InwardIDEncrypted: values?.InwardIDEncrypted,
              ReportingIDEncrypted: values?.ReportingIDEncrypted,
              InwardMaterialIDEncrypted:
                values?.InwardMaterialIDEncrypted ?? "",
              CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
                ? AuthUser?.ReferenceIDEncrypt
                : "0",
              EmailIDs: emailCsv,
              TestIDs: testIDs,
              ContactPersonName: ContactPersonName,
              InwardNo: values?.InwardNo,
              TCNo: cleanCsvString(TCNos), // values?.TCNo,
              InwardMaterialIDs: cleanCsvString(InwardMaterialIDs),
              ULRNoGenerateInwardWise:
                AuthUser?.ULRNoGenerateInwardWise === true ? "1" : "0",
            };

            await post(POST_ReportingsSendDraftCopyEmailSend, payload)
              .then((response) => {
                if (response?.IsSuccess) {
                  successMessage(response?.Message);
                  getData(currentPage, currentSizePerPage);
                  setShowSendDraftCopyEmailModal(false);
                } else {
                  errorMessage(response?.Message);
                }
                setIsLoading(false);
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
              });
          }
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const getTestDetailsAndProject = async (
    InwardMaterialIDEncrypt,
    InwardID,
  ) => {
    //setIsLoading(true);

    setIsLoading(true);
    await post(POST_GetReportingsSendDraftCopyEmail, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: AuthUser?.ULRNoGenerateInwardWise
        ? ""
        : InwardMaterialIDEncrypt,
      InwardIDEncrypted: AuthUser?.ULRNoGenerateInwardWise ? InwardID : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendDraftCopyEmail.setFieldValue(
            "ListOfCustomerContactPerson",
            response?.CustomerDetails?.filter(
              (x) => x.ContactPersonEmailID !== "",
            )?.map((item) => ({
              CustomerName: item.CustomerName,
              ProjectName: item.ProjectName,
              Address: item?.Address,
              ContactPerson: item?.ContactPerson,
              Designation: item?.Designation,
              MobileNo: item?.MobileNo,
              ContactPersonEmailID: item?.ContactPersonEmailID,
              ContactPersonID: item?.ContactPersonID,
              IsSelected: true,
            })),
          );

          formikSendDraftCopyEmail.setFieldValue(
            "ListOfReportingTest",
            response?.ListOfInwardMaterials,
          );

          // formikSendDraftCopyEmail.setFieldValue(
          //   "ListOfReportingTest",
          //   response?.ListOfReportingsTest?.map((x, indx) => ({
          //     InwardMaterialTestDetailIDEncrypt:
          //       x?.InwardMaterialTestDetailIDEncrypt,
          //     TestName: x?.TestName,
          //     Sequence: x?.Sequence == 0 ? indx + 1 : x?.Sequence,
          //     PageBreak: x?.PageBreak,
          //     ReportDetailID: x?.ReportDetailIDEncrypt,
          //     ReportingID: x?.ReportingIDEncrypt,
          //     TestMasterID: x?.TestMasterIDEncrypt,
          //     ReportDetailDate: x?.ReportDetailDate
          //       ? new Date(x?.ReportDetailDate)
          //       : "",
          //     PrintingStatus: x?.PrintingStatus,
          //     InwardMaterialIDEncrypt: x?.InwardMaterialIDEncrypt,
          //     TCNo: x?.TCNo,
          //     IsSelected: false,
          //   }))
          // );
        } else {
          //Reset Details
          formikSendDraftCopyEmail.setFieldValue("InwardMaterialIDEncrypt", "");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaReportPrintingApproval = Yup.object().shape({});

  const formikReportPrintingApproval = useFormik({
    validationSchemaReportPrintingApproval,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitReportPrintingApproval(values, formikHelpers),
    initialValues: {
      InwardNo: "",
      TCNo: "",
      ReportingIDEncrypted: "",
      ListOfTests: [],
      selectAllTests: false,
      InwardIDEncrypted: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfTests, selectAllTests },
  } = formikReportPrintingApproval;

  const handleValidSubmitReportPrintingApproval = async (values) => {
    setIsLoading(true);

    let payload = {
      ReportingIDEncrypted: values?.ReportingIDEncrypted,
      ListOfTests: values?.ListOfTests?.map((x) => ({
        ...x,
        ApprovalStatus: x.IsSelected ? 1 : 0,
      })),
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };

    await post(POST_ReportPrintingApproval, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowReportPrintingApprovalModal(false);
          getData(currentPage, currentSizePerPage);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showReportPrintingApprovalModal, setShowReportPrintingApprovalModal] =
    useState(false);

  const openReportPrintingApprovalDialog = async (
    InwardNo,
    TCNo,
    ReportingID,
    InwardID,
  ) => {
    formikReportPrintingApproval.resetForm();

    formikReportPrintingApproval.setFieldValue("InwardNo", InwardNo);
    formikReportPrintingApproval.setFieldValue("TCNo", TCNo);
    formikReportPrintingApproval.setFieldValue(
      "ReportingIDEncrypted",
      ReportingID,
    );
    formikReportPrintingApproval.setFieldValue("InwardIDEncrypted", InwardID);

    setIsLoading(true);
    await post(POST_GetReportPrintingApprovalDetail, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      ReportingIDEncrypted: ReportingID,
      InwardIDEncrypted: InwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikReportPrintingApproval.setFieldValue(
            "ListOfTests",
            response?.TestList?.map((item) => ({
              ...item,
              IsSelected: item?.ApprovalStatus == 1 ? true : false,
              IsDisabled: item?.PrintingStatus == 2 ? true : false,
            })),
          );
        }
        setIsLoading(false);
        setShowReportPrintingApprovalModal(true);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSelectAllTests = (isChecked) => {
    formikReportPrintingApproval.setFieldValue("selectAllTests", isChecked);
    formikReportPrintingApproval.setFieldValue(
      "ListOfTests",
      ListOfTests?.map((x) => {
        return { ...x, IsSelected: x.IsDisabled ? x.IsSelected : isChecked };
      }),
    );
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Report Printing List</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "} Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                      // setShowFilter(false);
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerID"
                              placeholder={"Select Customer"}
                              options={customerOptionList}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Status"
                              name="ReportingStatus"
                              placeholder={"Select  Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                        </Row>
                        <Row className="me-0">
                          {AuthUser?.Permissions?.UploadScanCopy == 1 && (
                            <Col lg={3}>
                              <Field
                                label="Upload Scan Copy"
                                name="UploadScanCopy"
                                placeholder={"Select Scan Copy"}
                                options={uploadScanCopyOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                          )}

                          <Col lg={3}>
                            <div className="d-flex">
                              <Field
                                label="From Date"
                                name="FromDate"
                                placeholder={"Select From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              {/* </Col>
                          <Col lg={3}> */}
                              <div>&nbsp;</div>
                              <Field
                                label="To Date"
                                name="ToDate"
                                placeholder={"Select To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Representative"
                              name="CustomerRepresentativeIDEncrypt"
                              placeholder={"Select Representative"}
                              options={customerRepresentativeOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="Reporting-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Reporting-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="4%"></th>
                        <th
                          style={{
                            width: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No/Date{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.ULRNoGenerateInwardWise === false ? (
                          <th
                            style={{
                              width: "25%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("SampleDetail");
                            }}
                          >
                            Sample Detail{" "}
                            <span className="ml-1">
                              {sortBy == "SampleDetail" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerRepresentativeName");
                          }}
                        >
                          Representative{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerRepresentativeName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("EDD");
                          }}
                        >
                          EDD{" "}
                          <span className="ml-1">
                            {sortBy == "EDD" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.Permissions?.Email == 1 ? (
                          <th
                            style={{
                              width: "9%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("MailSent");
                            }}
                          >
                            Mail Send{" "}
                            <span className="ml-1">
                              {sortBy == "MailSent" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("ReportingStatus");
                          }}
                        >
                          Status{" "}
                          <span className="ml-1">
                            {sortBy == "ReportingStatus" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportingList?.length > 0 ? (
                        reportingList?.map((item, indx) => (
                          <React.Fragment key={indx}>
                            <tr
                              key={indx}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                formik.setFieldValue(
                                  `reportingList[${indx}].showTest`,
                                  !item.showTest,
                                );
                              }}
                            >
                              <td
                                style={{ verticalAlign: "top" }}
                                rowSpan={
                                  item.TestList?.length > 0
                                    ? item?.showTest == true
                                      ? 2
                                      : 1
                                    : 1
                                }
                              >
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 34 && (x?.IsAdd || x?.IsEdit),
                                )?.length > 0 ? (
                                  <Link
                                    to={
                                      item?.IsHold == true
                                        ? "#"
                                        : `/add-report-printing/${window.btoa(
                                            AuthUser?.ULRNoGenerateInwardWise ===
                                              false
                                              ? item.InwardMaterialIDEncrypted
                                              : item.InwardIDEncrypted,
                                          )}`
                                    }
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {AuthUser?.ULRNoGenerateInwardWise === false
                                  ? item?.ReportingStatus > 1 &&
                                    item?.ReportingIDEncrypted &&
                                    (AuthUser?.UserType !== 1 ||
                                      AuthUser?.Permissions
                                        ?.IsReportPrintApprover == true) &&
                                    AuthUser?.Permissions?.ApprovalWorkflow ==
                                      1 &&
                                    AuthUser?.Permissions
                                      ?.ReportPrintApprovalRequired == true && (
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light"
                                        className="icon-box icon-box-md me-1"
                                        title="Approve"
                                        onClick={() => {
                                          if (item?.IsHold == false) {
                                            openReportPrintingApprovalDialog(
                                              item?.InwardNo,
                                              item?.TCNo,
                                              item?.ReportingIDEncrypted,
                                              "",
                                            );
                                          }
                                        }}
                                        disabled={item?.IsHold}
                                      >
                                        {item.TotalTests ==
                                        item.TotalTestApproved
                                          ? SVGICON.Verified
                                          : SVGICON.Unverified}
                                      </Link>
                                    )
                                  : item?.ReportingStatus > 1 &&
                                    (AuthUser?.UserType !== 1 ||
                                      AuthUser?.Permissions
                                        ?.IsReportPrintApprover == true) &&
                                    AuthUser?.Permissions?.ApprovalWorkflow ==
                                      1 &&
                                    AuthUser?.Permissions
                                      ?.ReportPrintApprovalRequired == true && (
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light"
                                        className="icon-box icon-box-md me-1"
                                        title="Approve"
                                        onClick={() => {
                                          if (item?.IsHold == false) {
                                            openReportPrintingApprovalDialog(
                                              item?.InwardNo,
                                              item?.TCNo,
                                              "",
                                              //item?.ReportingIDEncrypted,
                                              item?.InwardIDEncrypted,
                                            );
                                          }
                                        }}
                                        disabled={item?.IsHold}
                                      >
                                        {item.TotalTests ==
                                        item.TotalTestApproved
                                          ? SVGICON.Verified
                                          : SVGICON.Unverified}
                                      </Link>
                                    )}

                                {/* {item.ScanCopyFilePath ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md bg-primary-light me-1"
                                    title="Scan Copy Download"
                                    onClick={() => {
                                      window.open(
                                        item.ScanCopyFilePath,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    {SVGICON.Download}
                                 
                                  </Link>
                                ) : (
                                  ""
                                )} */}
                                {item?.ReportingStatus == 3 &&
                                (AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 37 && x?.IsAdd,
                                  )?.length > 0) ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Upload Scan Copy"
                                    onClick={(e) => {
                                      if (item?.IsHold == false) {
                                        addUploadScanCopy();
                                        formikUploadScanCopy.setFieldValue(
                                          "InwardMaterialIDEncrypt",
                                          "",
                                        );
                                        formikUploadScanCopy.setFieldValue(
                                          "InwardIDEncrypted",
                                          "",
                                        );
                                        formikUploadScanCopy.setFieldValue(
                                          "InwardMaterialIDEncrypt",
                                          item.InwardMaterialIDEncrypted,
                                        );
                                        formikUploadScanCopy.setFieldValue(
                                          "UploadScanCopyIDEncrypt",
                                          item.UploadScanCopyIDEncrypted,
                                        );

                                        formikUploadScanCopy.setFieldValue(
                                          "InwardIDEncrypted",
                                          item?.InwardIDEncrypted,
                                        );

                                        setTCNumber(item.TCNo);
                                        setUploadScanCopyFilePath(
                                          item.ScanCopyFilePath,
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {/* Upload / View */}
                                    {/* <i className="fa fa-cloud-upload"></i> */}
                                    {item.ScanCopyFilePath
                                      ? SVGICON.Download
                                      : SVGICON.Upload}
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {AuthUser?.ULRNoGenerateInwardWise === false ? (
                                  item?.ReportingIDEncrypted &&
                                  !item?.ScanCopyFilePath &&
                                  (AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) => x?.FormID == 34 && x?.IsDelete,
                                    )?.length > 0) ? (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        if (item?.IsHold == false) {
                                          delete_Record(
                                            POST_ReportingsDelete,
                                            {
                                              ReportingIDEncrypted:
                                                item?.ReportingIDEncrypted,
                                              ModifiedByEncrypted:
                                                AuthUser?.ReferenceIDEncrypt
                                                  ? AuthUser?.ReferenceIDEncrypt
                                                  : "0",
                                            },
                                            setIsLoading,
                                            fnCallback,
                                            item.TCNo,
                                          );
                                        }
                                      }}
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  ) : (
                                    ""
                                  )
                                ) : !item?.ScanCopyFilePath &&
                                  (AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) => x?.FormID == 34 && x?.IsDelete,
                                    )?.length > 0) ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        delete_Record(
                                          POST_ReportingsDelete,
                                          {
                                            ReportingIDEncrypted:
                                              item?.ReportingIDEncrypted,
                                            ModifiedByEncrypted:
                                              AuthUser?.ReferenceIDEncrypt
                                                ? AuthUser?.ReferenceIDEncrypt
                                                : "0",
                                          },
                                          setIsLoading,
                                          fnCallback,
                                          item.TCNo,
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {item?.ReportingStatus == 3 &&
                                AuthUser?.Permissions?.Email == 1 &&
                                (AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 37 && x?.IsAdd,
                                  )?.length > 0) ? (
                                  <Link
                                    to="#"
                                    // style={{ display: "none" }}
                                    className="icon-box icon-box-md me-1"
                                    title="Send Draft Copy Email"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        openSendDraftCopyEmailDialog(
                                          item?.InwardMaterialIDEncrypted,
                                          item?.InwardIDEncrypted,
                                          item?.InwardNo,
                                          item?.TCNo,
                                          item?.ReportingIDEncrypted,
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.SendEmail}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.TCNo}{" "}
                                {item?.IsHold == true && (
                                  <>
                                    <b>[Hold]</b>
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      key={indx}
                                      responsive={true}
                                      overlay={
                                        <Tooltip className="toltip-popover">
                                          <strong className="p-1">
                                            <label>Hold:</label>{" "}
                                            {item?.HoldReason}
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle ms-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                  </>
                                )}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.InwardNo}
                              </td>
                              {AuthUser?.ULRNoGenerateInwardWise === false ? (
                                <td
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }}
                                  className="popupOverlay"
                                >
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    key={indx}
                                    responsive={true}
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <strong className="p-1">
                                          {item.SampleDetail}
                                        </strong>
                                      </Tooltip>
                                    }
                                  >
                                    <span>{item.SampleDetail}</span>
                                  </OverlayTrigger>
                                </td>
                              ) : (
                                ""
                              )}
                              <td style={{ verticalAlign: "top" }}>
                                {item.CustomerRepresentativeName}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.EDD}
                              </td>
                              {AuthUser?.Permissions?.Email == 1 ? (
                                <td style={{ verticalAlign: "top" }}>
                                  {item.MailSent == true ? (
                                    <>
                                      Yes <br></br>
                                      {item.MailSentBy}
                                      <br></br>
                                      {item.MailSentDate}
                                    </>
                                  ) : (
                                    "No"
                                  )}
                                </td>
                              ) : (
                                ""
                              )}
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                              >
                                {item.ReportingStatusName}
                              </td>
                            </tr>

                            {item.TestList?.length > 0 ? (
                              <tr
                                style={{
                                  display: item.showTest == true ? "" : "none",
                                }}
                              >
                                {/* <td></td> */}
                                {/* <td colSpan={5}>
                                  <div className="table-responsive no-footer">
                                    <table className="table dataTable no-footer mb-0">
                                      <tr>
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "justify",
                                            whiteSpace: "initial",
                                            borderBottomColor: "transparent",
                                          }}
                                        > */}
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "initial",
                                    verticalAlign: "top",
                                  }}
                                  className="p-2"
                                >
                                  {item.TestList?.map((itemtest, indxtest) => (
                                    <Link
                                      key={indxtest}
                                      className="btn-sm me-2"
                                      to="#"
                                      style={{
                                        backgroundColor:
                                          itemtest?.TestingStatus == 1
                                            ? "#ed7c79"
                                            : itemtest?.TestingStatus == 2
                                              ? "#80c9ff"
                                              : itemtest?.TestingStatus == 3
                                                ? "#4aa493"
                                                : itemtest?.TestingStatus == 4
                                                  ? "#419841"
                                                  : itemtest?.TestingStatus == 5
                                                    ? "#f79f50"
                                                    : "",
                                        color: "#fff",
                                        cursor: "default",
                                      }}
                                    >
                                      {itemtest.TestName}
                                    </Link>
                                  ))}
                                </td>
                                {/* </tr>
                                    </table>
                                  </div>
                                </td> */}
                              </tr>
                            ) : (
                              ""
                            )}
                            {/* {item.TestList?.length > 0 ? (
                              <tr>
                                <td></td>
                                <td colSpan={5}>
                                  <div className="table-responsive no-footer">
                                    <table className="table dataTable no-footer mb-0">
                                      <tr>
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "justify",
                                            whiteSpace: "initial",
                                            borderBottomColor: "transparent",
                                          }}
                                        >
                                          {item.TestList?.map(
                                            (itemtest, indxtest) => (
                                              <>
                                                <Link
                                                  to="#"
                                                  className="badge mb-2 me-2"
                                                  title={itemtest.TestName}
                                                  style={{
                                                    backgroundColor:
                                                      itemtest.TestingStatus ==
                                                      1
                                                        ? "#ed7c79"
                                                        : itemtest.TestingStatus ==
                                                          2
                                                        ? "#80c9ff"
                                                        : itemtest.TestingStatus ==
                                                          3
                                                        ? "#4aa493"
                                                        : itemtest.TestingStatus ==
                                                          4
                                                        ? "#419841"
                                                        : itemtest.TestingStatus ==
                                                          5
                                                        ? "#f79f50"
                                                        : "",
                                                    color: "#fff",
                                                  }}
                                                >
                                                  {itemtest.TestName}
                                                </Link>
                                              </>
                                            )
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )} */}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={addUploadScanCopyModal}
            onHide={setAddUploadScanCopyModal}
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikUploadScanCopy}>
                <Form onSubmit={formikUploadScanCopy.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Upload Scan Copy {""}(TC No. : {tCNumber})
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setAddUploadScanCopyModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div className="d-flex justify-content-between">
                          <label className="mb-1">
                            Upload Scan Copy{" "}
                            <span className="text-danger">*</span>
                          </label>
                          {uploadScanCopyFilePath ? (
                            <Link
                              to="#"
                              title="Download Scan Copy"
                              className="fs-14 text-secondary"
                              onClick={() => {
                                window.open(uploadScanCopyFilePath, "_blank");
                              }}
                            >
                              <i className="fa fa-download"></i> Download
                            </Link>
                          ) : (
                            ""
                          )}
                        </div>

                        <input
                          type="file"
                          id="UploadScanCopyFile"
                          accept="image/png, image/gif, image/jpeg,application/pdf"
                          className="form-control form-control-sm"
                          onChange={uploadUploadScanCopyFile}
                        />
                        <ErrorMessage
                          name="UploadScanCopyFile"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        {/* <label htmlFor="UploadScanCopyFile" name=""></label> */}
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      // variant="primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa fa-cloud-upload"></i> Upload
                    </Button>
                    <Button
                      // variant="danger light"
                      variant="danger btn-sm"
                      onClick={() => setAddUploadScanCopyModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>

          <Modal
            className="fade"
            show={showSendDraftCopyEmailModal}
            onHide={setShowSendDraftCopyEmailModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendDraftCopyEmail}>
                <Form onSubmit={formikSendDraftCopyEmail.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Send Draft Copy Email</Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowSendDraftCopyEmailModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div className="d-flex justify-content-between mb-2">
                          <h5 className="mb-0">Reporting Contact Person</h5>
                        </div>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="CustomerContactPersons-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="CustomerContactPersons-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "20%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "24%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfCustomerContactPerson?.length > 0 ? (
                                  ListOfCustomerContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedCCP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendDraftCopyEmail.setFieldValue(
                                                `ListOfCustomerContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected,
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.ContactPersonEmailID}
                                        </td>
                                      </tr>
                                    ),
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>

                    <Row>
                      <Col lg={6}>
                        <div className="d-flex justify-content-between mb-2">
                          <h5 className="mb-0">Test</h5>
                        </div>

                        <div className="card-body p-2">
                          <div
                            className="basic-form"
                            style={{
                              overflow: "auto",
                              maxHeight: "500px",
                            }}
                          >
                            <Accordion
                              className="accordion accordion-primary"
                              defaultActiveKey={InwardMaterialIDEncrypted}
                            >
                              {ListOfReportingTest?.length > 0
                                ? ListOfReportingTest?.map((item, index) => (
                                    <>
                                      <Accordion.Item
                                        className="accordion-item"
                                        key={index}
                                        eventKey={item?.InwardMaterialIDEncrypt}
                                      >
                                        <Accordion.Header className="accordion-header rounded-lg">
                                          <b>TC No : </b> &nbsp;
                                          {item.TCNo} &nbsp;
                                        </Accordion.Header>
                                        <Accordion.Collapse
                                          eventKey={
                                            item?.InwardMaterialIDEncrypt
                                          }
                                        >
                                          <div
                                            className="accordion-body"
                                            style={{
                                              overflowX: "auto",
                                            }}
                                          >
                                            <div className="row">
                                              <div className="table-responsive active-projects style-1 shorting">
                                                <div
                                                  id="Test-tbl_wrapper"
                                                  className="dataTables_wrapper no-footer"
                                                >
                                                  <table
                                                    id="Test-tbl"
                                                    className="table dataTable no-footer"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            width: "5%",
                                                          }}
                                                        ></th>
                                                        <th
                                                          style={{
                                                            width: "5%",
                                                          }}
                                                        ></th>

                                                        <th
                                                          style={{
                                                            width: "90%",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Test Name
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {item
                                                        ?.ListOfReportingsTest
                                                        ?.length > 0 ? (
                                                        item?.ListOfReportingsTest?.map(
                                                          (itemsub, idx) => (
                                                            <tr>
                                                              <td>{idx + 1}</td>
                                                              <td>
                                                                <input
                                                                  className="form-check-input"
                                                                  type="checkbox"
                                                                  id="checkIsSelectedRT"
                                                                  checked={
                                                                    itemsub?.IsSelected
                                                                  }
                                                                  onChange={() => {
                                                                    formikSendDraftCopyEmail.setFieldValue(
                                                                      `ListOfReportingTest[${index}].ListOfReportingsTest[${idx}].IsSelected`,
                                                                      !itemsub?.IsSelected,
                                                                    );
                                                                  }}
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                ></input>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                {
                                                                  itemsub?.TestName
                                                                }
                                                              </td>
                                                            </tr>
                                                          ),
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            colSpan={4}
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <div>
                                                              {
                                                                "No Record Found..."
                                                              }
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Collapse>
                                      </Accordion.Item>
                                    </>
                                  ))
                                : ""}
                            </Accordion>
                          </div>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="d-flex justify-content-between mb-2">
                          Additional Email
                        </div>
                        <Field
                          // label="Additional Email"
                          name="AdditionalEmailID"
                          placeholder={"Enter Additional Email"}
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      // variant="primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa fa-envelope"></i> Send Mail
                    </Button>
                    <Button
                      // variant="secondary light"
                      variant="danger btn-sm"
                      onClick={() => setShowSendDraftCopyEmailModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>

          <Modal
            className="fade"
            show={showReportPrintingApprovalModal}
            onHide={setShowReportPrintingApprovalModal}
            backdrop="static"
            size="lg"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikReportPrintingApproval}>
                <Form onSubmit={formikReportPrintingApproval.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Report Printing Approval (TC No. :{" "}
                      {formikReportPrintingApproval.values?.TCNo})
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowReportPrintingApprovalModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div
                          className="table-responsive active-projects style-1 shorting"
                          style={{ maxHeight: "450px" }}
                        >
                          <div
                            id="Tests-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="Tests-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead className="fixedheader">
                                <tr>
                                  <th width="3%" className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkSelectAllTests`}
                                      name={`chkSelectAllTests`}
                                      checked={selectAllTests}
                                      onChange={(e) => {
                                        handleChangeSelectAllTests(
                                          e?.target?.checked,
                                        );
                                      }}
                                    />
                                  </th>
                                  <th width="85%">Test Name</th>
                                  <th width="12%" style={{ textAlign: "left" }}>
                                    Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfTests?.length > 0 ? (
                                  ListOfTests?.map((test, iTest) => (
                                    <tr key={iTest}>
                                      <td className="p-1">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkIsSelected${iTest}`}
                                          name={`chkIsSelected${iTest}`}
                                          checked={test.IsSelected}
                                          disabled={test.IsDisabled}
                                          onChange={(e) => {
                                            formikReportPrintingApproval.setFieldValue(
                                              "selectAllTests",
                                              false,
                                            );
                                            formikReportPrintingApproval.setFieldValue(
                                              `ListOfTests[${iTest}].IsSelected`,
                                              e?.target?.checked,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td className="p-1">{test?.TestName}</td>
                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        {test?.PrintingStatusName}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-regular fa-circle-check"></i> Approved
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowReportPrintingApprovalModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ReportPrinting;
